<template>
  <div class="section">
    <h2 class="section-title">销售订单</h2>
    <div v-for="d in displayData" class="section-block">
      <h3 class="block-title">{{ d.title }}</h3>
      <div
        :class="{
          'block-displaycontent': true,
          'block-displaycontent-editable': !d.lock && fieldEditing !== d.key,
        }"
        @click="!d.lock && fieldEditing !== d.key && editField(d.key, d.type)"
      >
        <span v-if="fieldEditing !== d.key" class="block-displaytext">
          {{
          displayText[d.key] || "-"
          }}
        </span>
        <div v-else>
          <InputNumber
            v-if="d.type === 'Number'"
            :min="0"
            v-model="updateContent.volPlan"
            :ref="d.key"
            style="width: 100px"
            :disabled="
              !(
                user.superAdmin ||
                arrayIntersection(
                  ['allFactoryLeader', 'sales', 'factoryLeader'],
                  user.simpleRole
                ).length > 0
              ) || salesOrder.startedAt
            "
          ></InputNumber>
          <div v-else-if="d.type === 'DateTime'">
            <DatePicker
              v-model="updateContent.date"
              type="date"
              :options="planArrivedAtOptions"
              style="width: 120px"
              :disabled="
                !(
                  user.superAdmin ||
                  arrayIntersection(
                    ['allFactoryLeader', 'sales', 'factoryLeader'],
                    user.simpleRole
                  ).length > 0
                ) || salesOrder.startedAt
              "
            ></DatePicker>
            <Select
              v-model="updateContent.time"
              filterable
              style="margin-left: 8px; width: 80px"
              :disabled="
                !(
                  user.superAdmin ||
                  arrayIntersection(
                    ['allFactoryLeader', 'sales', 'factoryLeader'],
                    user.simpleRole
                  ).length > 0
                ) || salesOrder.startedAt
              "
            >
              <Option
                v-for="time in timeOptions"
                :value="time.label"
                :key="time.label"
              >{{ time.label }}</Option>
            </Select>
          </div>
          <Input
            v-else-if="d.type === 'TextArea'"
            v-model="updateContent.remark"
            type="textarea"
            :rows="3"
            :disabled="
              !(
                user.superAdmin ||
                arrayIntersection(
                  ['allFactoryLeader', 'sales', 'factoryLeader'],
                  user.simpleRole
                ).length > 0
              ) || salesOrder.startedAt
            "
            placeholder="输入备注..."
          />
          <span v-else>编辑出错</span>
        </div>
      </div>
      <div v-if="fieldEditing === d.key" style="margin: 4px 0 0 130px">
        <Button type="primary" size="small" style="width: 64px" @click="fieldEditSave()">保存</Button>
        <Button size="small" style="margin-left: 8px" @click="fieldEditing = null">取消</Button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapState } from "vuex";
import { arrayIntersection } from "@/utils";

export default {
  name: "SecSO",
  data() {
    return {
      dayjs,
      salesOrder: null,
      fieldEditing: null,
      updateContent: {
        volPlan: null,
        date: null,
        time: null,
        remark: null
      },
      planArrivedAtOptions: {
        shortcuts: [
          {
            text: "今天",
            value() {
              return new Date();
            }
          },
          {
            text: "明天",
            value() {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              return date;
            }
          },
          {
            text: "后天",
            value() {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
              return date;
            }
          }
        ]
      },
      timeOptions: [],
      displayData: {
        customer: {
          key: "customer",
          title: "客户",
          lock: true,
          type: "String",
          displayText: "-"
        },
        product: {
          key: "product",
          title: "产品",
          lock: true,
          type: "String",
          displayText: "-"
        },
        volPlan: {
          key: "volPlan",
          title: "需求数量",
          lock: false,
          type: "Number",
          displayText: "-"
        },
        planArrivedAt: {
          key: "planArrivedAt",
          title: "需求时间",
          lock: false,
          type: "DateTime",
          displayText: "-"
        },
        remark: {
          key: "remark",
          title: "备注",
          lock: false,
          type: "TextArea",
          displayText: "-"
        },
        createdBy: {
          key: "createdBy",
          title: "创建人",
          lock: true,
          type: "String",
          displayText: "-"
        },
        createdAt: {
          key: "createdAt",
          title: "创建时间",
          lock: true,
          type: "String",
          displayText: "-"
        }
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.currentUser
    }),
    displayText: function() {
      let content = {};
      if (this.salesOrder) {
        content.customer = this.salesOrder.customer.name;
        content.product = this.salesOrder.material?.model;
        content.volPlan = this.salesOrder.volPlan;
        content.remark = this.salesOrder.remark;
        content.createdBy = this.salesOrder.createdBy.name;
        content.planArrivedAt = this.salesOrder.planArrivedAt
          ? dayjs(this.salesOrder.planArrivedAt).format("M月D日 HH:mm")
          : null;
        content.createdAt = this.salesOrder.createdAt
          ? dayjs(this.salesOrder.createdAt).format("M月D日 HH:mm")
          : null;
      }
      return content;
    }
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      updateSalesOrder: "salesOrder/updateSalesOrderAction"
    }),
    loadData(payload) {
      const temp_timeOptions = this.timeOptions;
      this.timeOptions = temp_timeOptions;

      this.salesOrder = payload.salesOrder;
      this.setupOriginUpdateContent();
    },
    setupOriginUpdateContent() {
      this.updateContent.date = dayjs(this.salesOrder.planArrivedAt).toDate();
      this.updateContent.time = dayjs(this.salesOrder.planArrivedAt).format(
        "HH:mm"
      );
      this.updateContent.volPlan = this.salesOrder.volPlan;
      this.updateContent.remark = this.salesOrder.remark;
    },
    editField(field, type) {
      this.fieldEditing = field;
      this.setupOriginUpdateContent();
    },
    async fieldEditSave() {
      let updateData = {};
      switch (this.fieldEditing) {
        case "planArrivedAt":
          updateData.planArrivedAt = dayjs(this.updateContent.date)
            .hour(parseInt(this.updateContent.time.substring(0, 2)))
            .minute(parseInt(this.updateContent.time.substring(3)));
          break;
        case "volPlan":
          updateData.volPlan = this.updateContent.volPlan;
          break;
        case "remark":
          updateData.remark = this.updateContent.remark;
          break;

        default:
          break;
      }

      try {
        this.salesOrder = await this.updateSalesOrder({
          id: this.salesOrder._id,
          data: updateData
        });
        this.fieldEditing = null;
      } catch (error) {
        this.$Message.error(`失败${error}`);
      }
    }
  },
  created() {
    for (let i = 0; i < 24; i++) {
      const h = i < 10 ? `0${i}` : `${i}`;
      this.timeOptions.push({ label: `${h}:00` });
      this.timeOptions.push({ label: `${h}:30` });
    }
  }
};
</script>

<style scoped lang="stylus">
.section
  display flex
  align-content flex-start
  flex-wrap wrap
  margin-bottom 12px

.section-title
  width 100%
  font-weight 450
  margin-bottom 12px
  color #3e3e3e

.block-title
  float left
  width 126px
  font-weight 400
  color #888

.block-displaycontent
  flex-grow 1
  max-height 90px
  overflow hidden
  padding 0 4px
  line-height 27px
  border 1px solid white

.block-displaycontent-editable
  cursor pointer
  transition 0.2s

  &:hover
    border 1px solid darkgray
    background-color #f7f7f7
    border-radius 2px

.block-displaytext
  font-weight 450
  font-size 14px

.section-block
  width 50%
  line-height 26px
  margin-bottom 8px
  padding-right 12px
</style>
